import type { Company, SelfFundedAccount } from 'src/shared/types/company';
import { SaldoItemStatus } from 'src/modules/SaldoView/components/CompanySelectorBar/components/SaldoItem';
import { type CompanyToSelect } from 'src/modules/SaldoView/types';
import getNumericBalance from 'src/shared/utils/getNumericBalance';

export const getStatusOfCompany = (account: SelfFundedAccount | undefined): SaldoItemStatus => {
  if (!account) {
    return SaldoItemStatus.DANGER;
  }
  const numericBalance = getNumericBalance(account.balance);
  if (numericBalance < 1) {
    return SaldoItemStatus.DANGER;
  }
  if (numericBalance <= account.lowOnFundsThreshold) {
    return SaldoItemStatus.WARNING;
  }
  return SaldoItemStatus.PRIMARY;
};

export const mapHoldingCompaniesToSelect = (
  data: Company[],
  selfFundedAccounts: SelfFundedAccount[]
): CompanyToSelect[] => {
  const allAccounts: Array<CompanyToSelect | undefined> = selfFundedAccounts.map(account => {
    const company = data.find(el => account?.taxIdentifier === el.taxIdentifier);
    if (!company) {
      return undefined;
    }
    return {
      value: company.id,
      label: company.name,
      status: getStatusOfCompany(account),
      createdAt: company.createdAt
    };
  });
  const filtered = allAccounts.filter(el => !!el) as CompanyToSelect[];
  return filtered.sort((a, b) => {
    const dateA = new Date(a.createdAt).getTime();
    const dateB = new Date(b.createdAt).getTime();
    return dateA - dateB;
  });
};
